// 船票订单-待付款类支付状态码
const UNPAID_PAYMENT_STATUS_CODES = ['Not_Payment', 'Not_Full_Payment']

export default {
    getBookingStatus (data) {
        var status='cancel';//判断舱房的状态
        if (this.isOpenBooking(data)) {
            if (data.bookingLocalStatus == 0) {
                status = 'unpaid'
            } else if (data.bookingLocalStatus == 20) {
                status = 'cancel'
            } else if (data.bookingLocalStatus == 25) {
                status = 'confirmed'
            }else {
                status = 'paid'
            }
        } else {
            var currentTime=new Date().getTime();
            var sailDate = new Date(data.sailDate).getTime();
            var balanceDue = data.balanceDue;
            var payAmount = data.payAmount;
            //未付款
            if (balanceDue == data.total) {
                status = 'unpaid';
            }
            //未付全款
            if (balanceDue > 0 && (balanceDue < data.total || (payAmount > 0 && payAmount < data.total))) {
                status = 'unpaidFull';
            }
            //已付款-未出行
            if ((balanceDue <= 0 || data.payAmount >= data.amount) && (sailDate > currentTime)) {
                status = 'paid';
                // // 总金额为0,支付金额为0
                // if(data.payAmount === 0 && data.amount === 0) {
                if(data.payAmount === 0) {
                    status = 'unpaidAndError';
                }
            }
            //已付款-已出行-已评价
            if ((balanceDue <= 0) && (sailDate < currentTime) && data.hasComment) {
                status = 'hasComment';
            }
            //已付款-已出行-未评价
            if ((balanceDue <= 0) && (sailDate < currentTime) && !data.hasComment) {
                status = 'noComment';
            }
            //已取消
            if (data.bookingStatus == 'CANCELLED') {
                status = 'cancel';
            }
        }
        return status;
    },
    isOpenBooking(data) {
        return data.openBookingOrderId && data.openBookingOrderId.length > 0
    },
    // 是否属于「待付款类」支付状态（未付款 / 未付全款）
    isUnpaidPaymentStatus(paymentStatusCode) {
        return UNPAID_PAYMENT_STATUS_CODES.indexOf(paymentStatusCode) >= 0
    }
    // 【已注释 2026-09-14】PC 端无有效调用：唯一调用点 BookingListItem.vue 的 statusName computed 全仓无引用
    // 注意：MB 仓库 (rccl-frontend-mb) 同名方法仍在用，且多一个 case 'unpaidAndError' -> '未付款'；如需启用请先与 MB 对齐
    // getStatusName (data) {
    //     let statusString = '已取消';
    //     const status = this.getBookingStatus(data)
    //     switch (status) {
    //         case 'cancel':
    //             statusString = '已取消';
    //             break;
    //         case 'unpaid':
    //             statusString = '未付款';
    //             break;
    //         case 'unpaidFull':
    //             statusString = '未付全款';
    //             break;
    //         case 'paid':
    //             statusString = '已付款';
    //             break;
    //         case 'confirmed':
    //             statusString = '已使用';
    //             break;
    //         case 'hasComment':
    //             statusString = '已付款';
    //             break;
    //         case 'noComment':
    //             statusString = '已付款';
    //             break;
    //         default:
    //             statusString = '已取消';
    //     }
    //     return statusString
    // }
}
